import * as autobind from 'autobind';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect } from 'redux-scaffolding-ts';
import { Button, Container, Form, Message, Modal, Dimmer, Loader } from 'semantic-ui-react';

import { ChangeOemDto, ChangeOemStore, OemDto } from '../../../../../stores/configuration/machinery/oems-store';
import { nameof } from '../../../../../utils/object';

interface ChangeOemViewProps extends WithTranslation {
  onClose: (isSuccess: boolean) => void;
  changeOem?: ChangeOemStore;
  currentOem: OemDto;
}

// tslint:disable-next-line:no-empty-interface
interface ChangeOemViewState {}

@connect(['changeOem', ChangeOemStore])
class ChangeOemView extends React.Component<ChangeOemViewProps, ChangeOemViewState> {
  private get changeOemStore() {
    return this.props.changeOem;
  }

  constructor(props: ChangeOemViewProps) {
    super(props);

    this.changeOemStore.state.result = null;

    this.changeOemStore.change({
      id: this.props.currentOem.id,
      name: this.props.currentOem.name
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps: ChangeOemViewProps) {
    if (this.changeOemStore.state.result && this.changeOemStore.state.result.isSuccess) {
      nextProps.onClose(true);
    }
  }

  @autobind
  private onChangeItem() {
    this.changeOemStore.update();
  }

  @autobind
  private onCancelChangeItem() {
    this.changeOemStore.clear();
    this.props.onClose(false);
  }

  @autobind
  private handleValue(property: string, value: any) {
    const change = {};
    change[property] = value;
    this.changeOemStore.change({ ...this.changeOemStore.state.item, ...change });
  }

  public render() {
    const { t } = this.props as any;

    return (
      <Modal open closeOnEscape={true} onClose={this.onCancelChangeItem} closeOnDimmerClick={false}>
        <Dimmer active={this.changeOemStore.state.isBusy} style={{ background: 'rgba(0, 0, 0, 0.4)' }}>
          <Loader indeterminate>{t('')}</Loader>
        </Dimmer>
        <Modal.Header className="modal__header">{t('Edit OEM')}</Modal.Header>
        <Modal.Content image>
          <Container>
            {this.changeOemStore.state.result && !this.changeOemStore.state.result.isSuccess && (
              <Message
                className="error-message__style"
                icon="exclamation circle"
                error
                header={t('An error ocurred')}
                list={this.changeOemStore.state.result.messages.map(o => o.body)}
              />
            )}
            {this.changeOemStore.state.item && (
              <Form>
                <Form.Field>
                  <Form.Input
                    required
                    fluid
                    label={t('OEM')}
                    placeholder={t('Name')}
                    value={this.changeOemStore.state.item.name}
                    onChange={(e, { value }) => this.handleValue(nameof<ChangeOemDto>('name'), value)}
                  />
                </Form.Field>
              </Form>
            )}
          </Container>
        </Modal.Content>
        <Modal.Actions>
          <Button className="basic" onClick={this.onCancelChangeItem}>
            {t('Cancel')}
          </Button>
          <Button onClick={this.onChangeItem} positive>
            {t('Save')}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

// Wire up the React component to the Redux store
export default withTranslation()(ChangeOemView);
